import React, {ReactNode, useCallback, useEffect, useMemo, useRef, useState} from 'react'
import WizTable from '../../../components/table/TableFactory'
import PageLayout from '../../../components/layout/PageLayout'
import {ComponentItem, CreateComponent} from '../../../components/useComponent'
import Text from '../../../components/text/Text'
import useQueryNft from '../../../hooks/api/unknownorder/useQueryUpbitNft'
import {useTime} from '../../../utils/time'
import WizPagination from '../../../components/pagination/WizPagination'
import WizModal from '../../../components/modal/WizModal'
import BalanceTimeLine from './BalanceTimeLine'

interface IProps {
    className?: string
}

const UpbitnftContainer: React.FC<IProps> = ({className}) => {
    const headerTitles: string[] = ['User ID', 'Status', 'Symbol', 'Amount', 'isUnknown', 'CreatedAt']
    const [currentPage, setCurrentPage] = useState(1)
    const [orderID, setOrderID] = useState('')
    const {data, refetch} = useQueryNft(currentPage)
    const {localTimeString} = useTime()
    const modalRef = useRef(null)
    const headers: ComponentItem[] = headerTitles.map<ComponentItem>(el => ({
        component: Text,
        props: {
            children: el,
        },
    }))

    const rows = useMemo(() => {
        if (data === undefined || data?.data?.length === 0) {
            return []
        }

        return data?.data?.map<ReactNode[]>(el => [
            <div
                onClick={() => showModalHandler(el.id)}
                className={'space-y-[5px] reak-words whitespace-normal max-w-xl'}>
                {CreateComponent(Text, {children: el.user_id})}
            </div>,
            <div className={'space-y-[5px] reak-words whitespace-normal max-w-xl'}>
                {CreateComponent(Text, {children: el.type})}
            </div>,
            <div className={'space-y-[5px] reak-words whitespace-normal max-w-xl'}>
                {CreateComponent(Text, {children: el.normalized_symbol})}
            </div>,
            <div className={'space-y-[5px] reak-words whitespace-normal max-w-xl'}>
                {CreateComponent(Text, {children: el.amount})}
            </div>,
            <div className={'space-y-[5px] reak-words whitespace-normal max-w-xl'}>
                {CreateComponent(Text, {children: `${el.is_unknown}`})}
            </div>,
            <div className={'space-y-[5px] reak-words whitespace-normal max-w-xl'}>
                {CreateComponent(Text, {children: localTimeString(el.created_at)})}
            </div>,
        ])
    }, [data, localTimeString])

    const showModalHandler = useCallback(order_id => {
        setOrderID(order_id)
        modalRef.current.show()
    }, [])

    useEffect(() => {
        refetch()
    }, [])

    return (
        <>
            <PageLayout className={''} title="Upbit NFT">
                <WizTable gridCols="6" className="w-full" headers={headers} items={rows} />
                <WizPagination
                    totalPage={data?.pageInfo?.total_count}
                    currentPage={currentPage}
                    onPageChange={item => setCurrentPage(item)}
                />
            </PageLayout>
            <WizModal ref={modalRef} className="w-[80vw] h-[100vh]">
                <BalanceTimeLine orderID={orderID} />
            </WizModal>
        </>
    )
}

export default UpbitnftContainer
